import api from './authService';

/**
 * Public site settings - no auth required. Used by ClientFooter and public pages.
 */
export const siteSettingsService = {
  get: async () => {
    const response = await api.get('/site-settings/public');
    return response.data;
  },
};
